import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { CookieService } from '../../services/cookie/cookie.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cookie = inject(CookieService);
  const modifiedReq = req.clone({
    setHeaders: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  return next(modifiedReq).pipe(
    tap((event: HttpEvent<any>) => {
      // Handle successful responses here
    }),
    catchError((error: any) => {
      if (
        error?.error?.message?.includes('Wrong session') ||
        error?.error?.includes('Wrong session')
      ) {
        localStorage.clear();
        cookie.clear();
        window.location.href = '/login';
      }
      return throwError(() => new Error(error?.error ? error.error : error));
    }),
  );
};
